import GlobalTable from "../../../../components/global-table";
import { Typography } from "../../../../ppui";
import { ContentHeading, ContentLayout, ContentTable } from "../../../style";
import { headers } from "./organization-data";
import useOrganizationTable from "./organization-table.service";

const OrganizationTableView = () => {
    const {
        organizations,
        handleNextPage,
        handlePreviousPage,
        handleRowsPerPageChange,
        totalPages,
        currentPage,
        rowsPerPage,
        searchQuery, 
        setSearchQuery
    } = useOrganizationTable()
    return (
        <ContentLayout>
        <ContentHeading>
            <Typography variant="h5" mb="0">
                Organization List
            </Typography>
        </ContentHeading>

        <ContentTable>
            <GlobalTable
                headers={headers}
                rows={organizations}
                ActiveSort={false}
                searchBox={true}
                columnManagement={false}
                avatar={true}
                rowsPerPage={rowsPerPage}
                currentPage={currentPage}
                totalPages={totalPages}
                handleNextPage={handleNextPage} // Pass next page handler
                handlePreviousPage={handlePreviousPage} // Pass previous page handler
                handleRowsPerPageChange={handleRowsPerPageChange} // Pass rows-per-page handler
                // // FetchDataFromRow={FetchDataFromRow}
                stickyHeader="true"
                searchQuery={searchQuery} setSearchQuery={setSearchQuery}
            />
        </ContentTable>
        
    </ContentLayout>
    )
    
}

export default OrganizationTableView;